<template>
  <div>

    <!-- License expired alert -->
    <b-alert :show="form.errors.has('license_expired')" variant="danger">
      <span v-html="$t('license_expired')"/>
    </b-alert>

    <!-- Unsupported browser -->
    <b-alert :show="unsupported" variant="danger">
      <span v-html="$t('unsupported_browser')"/>
    </b-alert>

    <!-- Form -->
    <form v-if="!unsupported" @submit.prevent="login" @keydown="form.onKeydown($event)">
      <!-- Email -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">{{ $t('nick_name') }}</label>
        <div class="col-md-6">
          <input v-model="form.nick_name" :class="{ 'is-invalid': form.errors.has('nick_name') }" class="form-control" type="text" name="nick_name">
          <form-error :form="form" field="nick_name"/>
        </div>
      </div>

      <!-- Password -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">{{ $t('password') }}</label>
        <div class="col-md-6">
          <input v-model="form.password" :class="{ 'is-invalid': form.errors.has('password') }" class="form-control" type="password" name="password">
          <form-error :form="form" field="password"/>
        </div>
      </div>

      <!-- Remember Me -->
      <div class="form-group row">
        <div class="col-md-3"/>
        <div class="col-md-6 d-flex">
          <checkbox v-model="remember" name="remember">
            {{ $t('remember_me') }}
          </checkbox>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-6 offset-md-3 d-flex">
          <!-- Submit Button -->
          <v-button :loading="form.busy">
            {{ $t('login') }}
          </v-button>
        </div>
      </div>
    </form>

  </div>
</template>

<script>
import Form from 'vform'
import { isRecipient, isProfessional, isManager, isStudent } from '~/plugins/auth'

export default {
  name: 'Login',

  data: () => ({
    form: new Form({
      nick_name: '',
      password: ''
    }),
    remember: false,
    unsupported: false
  }),

  created () {
    this.unsupported = navigator.userAgent.match(/Trident|MSIE/g)
  },

  methods: {
    async login () {
      // Submit the form.
      const { data } = await this.form.post('/api/login')

      // Save the token.
      this.$store.dispatch('auth/saveToken', {
        token: data.token,
        remember: this.remember
      })

      // Fetch the user.
      await this.$store.dispatch('auth/fetchUser')

      // Redirection.
      if (isRecipient(this.$store.state.auth.user)) { this.$router.push({ name: 'settings.profile', params: { id: this.$store.state.auth.user.id } }) } else {
        if (isProfessional(this.$store.state.auth.user) || isStudent(this.$store.state.auth.user)) { this.$router.push({ name: 'manage.recipients' }) } else { this.$router.push({ name: 'manage.users' }) }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/Login.vue